import {h, Fragment} from "preact"
import { useFacet } from '@nosto/preact'
import { useRef } from 'preact/hooks'
import { closeSiblingFacets } from '../helpers'

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const buttonRef = useRef(null)

    const handleToggle = (e) => {
        closeSiblingFacets(buttonRef.current)
    }

    return (
        <div class="collection-sidebar__group">
            <button
                ref={buttonRef}
                type="button"
                class="collapsible-trigger collapsible-trigger-btn collapsible--auto-height close-siblings tag-list__header"
                aria-controls={facet.id}
                aria-expanded="false"
                onClick={handleToggle}>
                {facet.name}
                <svg
                    role="presentation"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9 18L15 12L9 6"
                        stroke="#f4762d"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </button>
            <div id={facet.id} class="collapsible-content collapsible-content--sidebar" style="height: 0px">
                <div class="collapsible-content__inner">
                    <ul class="no-bullets tag-list tag-list--checkboxes">
                        {facet.data?.map((value) => (
                            <li
                                key={value.value}
                                class={`tag ${value.selected ? 'tag--active' : ''}`}
                                data-nosto-element="facet-setting"
                                role="menuitem">
                                <a
                                    onClick={(e) => {
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}>
                                    {value.value}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}
